import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=5a0401ed&scoped=true"
import script from "./Menu.js?vue&type=script&lang=js&external"
export * from "./Menu.js?vue&type=script&lang=js&external"
import style0 from "./Menu.scss?vue&type=style&index=0&id=5a0401ed&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0401ed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default})
